import { View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMDescriptionCard,
  PMSmallTable,
} from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";

/**
 * Adds the program description card and the (static, hard-coded) contracts
 * list card, in that order (#2222).
 */
export function addProgramAndContractsCards(
  view: View<TestAppState, DragAndDropLayout>
) {
  const programDescriptionComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "programDescriptionComponent",
      title: "",
      description: "",
      labels: ["Program", "Description"],
    },
  });

  programDescriptionComponent.mapLayoutProps(({ language }) => ({
    componentId: "programDescriptionComponent",
    labels: ["Program", "Description"],
    title: getLocalizedMessage(
      language || "en",
      "reportingStructure.programDescription"
    ),
    description: getLocalizedMessage(
      language || "en",
      "showsProgramDescription"
    ),
  }));

  programDescriptionComponent.mapState(({ settings }) => ({
    text: settings?.configuration?.programDescription ?? "",
  }));

  const contractsComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "contractsOverviewComponent",
      labels: ["contracts", "list"],
      description: "Shows a simple list of contracts.",
      title: "Contracts",
    },
  });

  contractsComponent.mapState(() => ({
    title: "Contracts",
    icon: "Description",
    items: [
      {
        label: "Name Test Contract 1",
        value: "PDF, contract-2025.pdf",
        chipColor: theme.palette.secondary.main,
        chipTextColor: theme.palette.primary.main,
      },
      {
        label: "Name Test Contract 2",
        value: "TXT, contract-XXX.txt",
        chipColor: theme.palette.secondary.main,
        chipTextColor: theme.palette.primary.main,
      },
    ],
    fixedHeight: "134px",
  }));
}
